import { render, staticRenderFns } from "./CompanyCompanyConfig.vue?vue&type=template&id=21d2cdc8"
import script from "./CompanyCompanyConfig.vue?vue&type=script&lang=js"
export * from "./CompanyCompanyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports